import iconAqiyi from '@/assets/icon-aqiyi.png'
import iconJD from '@/assets/icon-JD.png'
// import iconMeituan from '@/assets/icon-meituan.png'
import iconMetro from '@/assets/icon-metro.png'
import iconMetro3 from '@/assets/icon-metro-3.png'
import iconMetro5 from '@/assets/icon-metro-5.png'
import iconPhone from '@/assets/icon-phone.png'
import iconMetro_1 from '@/assets/icon-metro-1.png'
// import icon_danxiang from '@/assets/icon-danxiang.png'
export default [
    {
        type: 1,
        productId: 'DTQ1',
        productName: '1元钱包地铁乘车券',
        coinNum: 2,
        icon: iconMetro_1,
        rule: '1.单张1元钱包地铁乘车券有效期7天，自兑换之日起生效，仅限钱包乘坐地铁可用，逾期未使用自动作废。\n' +
            '2.单张钱包地铁乘车券仅可使用1次，不找零、不提现、不可代付，可与钱包内优惠活动同享，不与其他优惠活动同享。\n' +
            '3.钱包地铁乘车券可在首页“我的”-“优惠券”-“通用优惠券”中查看。\n' +
            '4.如遇乘车扣款失败，未扣费订单补款时此优惠券不予以抵扣。'
    },
    {
        type: 1,
        productId: 'DTQ2',
        productName: '2元钱包地铁乘车券',
        coinNum: 4,
        icon: iconMetro,
        rule: '1.单张2元钱包地铁乘车券有效期7天，自兑换之日起生效，仅限钱包乘坐地铁可用，逾期未使用自动作废。\n' +
            '2.单张钱包地铁乘车券仅可使用1次，不找零、不提现、不可代付，可与钱包内优惠活动同享，不与其他优惠活动同享。\n' +
            '3.钱包地铁乘车券可在首页“我的”-“优惠券”-“通用优惠券”中查看。\n' +
            '4.如遇乘车扣款失败，未扣费订单补款时此优惠券不予以抵扣。\n'
    },
    {
        type: 1,
        productId: 'DTQ3',
        productName: '3元钱包地铁乘车券',
        coinNum: 6,
        icon: iconMetro3,
        rule: '1.单张3元钱包地铁乘车券有效期7天，自兑换之日起生效，仅限钱包乘坐地铁可用，逾期未使用自动作废。\n' +
            '2.单张钱包地铁乘车券仅可使用1次，不找零、不提现、不可代付，可与钱包内优惠活动同享，不与其他优惠活动同享。\n' +
            '3.钱包地铁乘车券可在首页“我的”-“优惠券”-“通用优惠券”中查看。\n' +
            '4.如遇乘车扣款失败，未扣费订单补款时此优惠券不予以抵扣。\n'
    },
    {
        type: 1,
        productId: 'DTQ5',
        productName: '5元钱包地铁乘车券',
        coinNum: 10,
        icon: iconMetro5,
        rule: '1.单张5元钱包地铁乘车券有效期7天，自兑换之日起生效，仅限钱包乘坐地铁可用，逾期未使用自动作废。\n' +
            '2.单张钱包地铁乘车券仅可使用1次，不找零、不提现、不可代付，可与钱包内优惠活动同享，不与其他优惠活动同享。\n' +
            '3.钱包地铁乘车券可在首页“我的”-“优惠券”-“通用优惠券”中查看。\n' +
            '4.如遇乘车扣款失败，未扣费订单补款时此优惠券不予以抵扣。\n'
    },
   /* {
        type: 2,
        productId: 'MTWM5YDTZY20210219172638240',
        productName: '美团外卖5元券',
        coinNum: 10,
        icon: iconMeituan,
        rule: '1.券码有效期为30天，建议尽快使用，过期自动作废，无法延期或退换，请谅解!\n' +
            '2.登陆美团外卖APP，进入右下方“我的”，点击“红包/卡券”，选择“快捷兑券”，输入券码，点击“兑换”即可。\n' +
            '3.兑换成功后，使用该手机号登录美团外卖APP查看权益(如该手机号未注册美团外卖账号,30天内注册成功后权益将自动发放到账号;如30天内未注册，权益自动失效)；\n' +
            '4.兑换前请务必认真填写并核对手机号，如因个人原因，导致兑换错误，自行承担责任，兑换完成后不予退换；\n' +
            '5.一张外卖订单仅限使用一张红包，不叠加、不找零、不兑现；\n' +
            '6.一个兑换码仅可使用一次,仅用于外卖订单。每个用户每天仅可兑换五张。同一设备、IP、账号、银行卡或手机号均视为同一用户；\n' +
            '7.成功在美团外卖APP下单后红包即作废。订单申请退款后红包无法退还；\n' +
            '8.无法使用请致电美团外卖客服电话:10100011 (周一至周日10:00- 18:00，节假日除外)\n' +
            '9.请在2021年4月31日前使用。'
    },*/

    {
        type: 3,
        productId: 'SW5',
        productName: '5元话费',
        coinNum: 11,
        icon: iconPhone,
        rule: '1.中奖后在领取框内输入手机号码，即可进行充值。请仔细填写，充错号码无法退回。\n' +
            '2.月初月末充值繁忙，可能会出现延迟到账，一般30分钟内到账，最晚24小时到账。\n' +
            '3.话费奖品兑奖时请认真核对手机号码，携号转网号码、虚拟运营商号码暂不能提供充值服务。如遇话费充值失败问题，请致电4001570096进行咨询。\n' +
            '4.请在2021年4月31日前使用。'
    },
    {
        type: 3,
        productId: 'SW10',
        productName: '10元话费',
        coinNum: 22,
        icon: iconPhone,
        rule: '1.中奖后在领取框内输入手机号码，即可进行充值。请仔细填写，充错号码无法退回。\n' +
            '2.月初月末充值繁忙，可能会出现延迟到账，一般30分钟内到账，最晚24小时到账。\n' +
            '3.话费奖品兑奖时请认真核对手机号码，携号转网号码、虚拟运营商号码暂不能提供充值服务。如遇话费充值失败问题，请致电4001570096进行咨询。\n' +
            '4.请在2021年4月31日前使用。'
    },


/*    {
        type: 2,
        productId: 'DX20YDJQDTZY20210323101928232',
        productName: '20元丹香优惠券',
        coinNum: 30,
        icon: icon_danxiang,
        rule: '1.获得的字符券码，请自行截图，妥善保管。\n' +
            '2.进店使用时出示字符码可灵活消费、可积分兑换产品、可再次享受店内打折活动、可购买店内所有产品，此优惠券可在丹香线上商城使用。\n' +
            '3.凭此优惠券到门店可购买蛋糕、面包、点心、汤圆、粽子、月饼等店内所有产品；\n' +
            '4.本优惠券仅适用于山东青岛地区丹香门店。'
    },*/



    {
        type: 2,
        productId: 'AQYYKDTZY20210219172455157',
        productName: '爱奇艺月卡',
        coinNum: 30,
        icon: iconAqiyi,
        rule: '1.建议尽快使用，过期自动作废，无法延期或退换，请谅解!\n' +
            '2.兑换方法：\n' +
            '(1)爱奇艺APP兑换：打开爱奇艺APP-“我的”页面点击开通VIP会员-激活码，兑换激活码-输入兑换码和验证码，立即激活，完成。(苹果手机不支持此次操作) \n' +
            '(2)爱奇艺官网兑换：打开爱奇艺网页-点击右上角开通VIP-进入VIP开通页面，选择兑换激活码-输入兑换码和验证码选择兑换，完成。\n' +
            '3.爱奇艺黄金VIP兑换成功后即时生效，请填写正确的手机号码(即登陆爱奇艺时所用的手机号)，如填错手机号码，无法退还您所支付的金额/积分。无爱奇艺账号用户可直接填写当前使用手机号码，系统将自动注册账号后充值，短信通知您验证码登录。\n' +
            '4.兑换前请务必认真填写并核对手机号，如因个人原因，导致兑换错误，自行承担责任，兑换完成后不予退换。\n' +
            '5.爱奇艺黄金VIP使用注意事项，爱奇艺黄金VIP会员账号同一时间不能登陆2台以上设备，切勿分享账号以免造成封号/盜号;本产品可在PC端、Pad端、手机端享受VIP服务，电视端不可用;适用于爱奇艺中国大陆地区用户;\n' +
            '6.请在2021年4月31日前使用。'
    },
    {
        type: 2,
        productId: 'AQYJKDTZY20210219172509828',
        productName: '爱奇艺季卡',
        coinNum: 90,
        icon: iconAqiyi,
        rule: '1.建议尽快使用，过期自动作废，无法延期或退换，请谅解!\n' +
            '2.兑换方法：\n' +
            '(1)爱奇艺APP兑换：打开爱奇艺APP-“我的”页面点击开通VIP会员-激活码，兑换激活码-输入兑换码和验证码，立即激活，完成。(苹果手机不支持此次操作) \n' +
            '(2)爱奇艺官网兑换：打开爱奇艺网页-点击右上角开通VIP-进入VIP开通页面，选择兑换激活码-输入兑换码和验证码选择兑换，完成。\n' +
            '3.爱奇艺黄金VIP兑换成功后即时生效，请填写正确的手机号码(即登陆爱奇艺时所用的手机号)，如填错手机号码，无法退还您所支付的金额/积分。无爱奇艺账号用户可直接填写当前使用手机号码，系统将自动注册账号后充值，短信通知您验证码登录。\n' +
            '4.兑换前请务必认真填写并核对手机号，如因个人原因，导致兑换错误，自行承担责任，兑换完成后不予退换。\n' +
            '5.爱奇艺黄金VIP使用注意事项，爱奇艺黄金VIP会员账号同一时间不能登陆2台以上设备，切勿分享账号以免造成封号/盜号;本产品可在PC端、Pad端、手机端享受VIP服务，电视端不可用;适用于爱奇艺中国大陆地区用户;\n' +
            '6.请在2021年4月31日前使用。'
    },
    {
        type: 3,
        productId: 'SW50',
        productName: '50元话费',
        coinNum: 110,
        icon: iconPhone,
        rule: '1.中奖后在领取框内输入手机号码，即可进行充值。请仔细填写，充错号码无法退回。\n' +
            '2.月初月末充值繁忙，可能会出现延迟到账，一般30分钟内到账，最晚24小时到账。\n' +
            '3.话费奖品兑奖时请认真核对手机号码，携号转网号码、虚拟运营商号码暂不能提供充值服务。如遇话费充值失败问题，请致电4001570096进行咨询。\n' +
            '4.请在2021年4月31日前使用。'
    },


    /*    {
            productId: 'JDEK10YDTZY20210219172528980',
            productName: '京东E卡10元',
            coinNum: 0,
            icon:iconJD
        },*/
    {
        type: 2,
        productId: 'JDEK50YDTZY20210219172548876',
        productName: '京东E卡50元',
        coinNum: 110,
        icon: iconJD,
        rule: '1.建议尽快使用，过期自动作废，无法延期或退换，请谅解!\n' +
            '2.京东E卡绑定账户后， 只能当前账户使用，不能跨账户使用。\n' +
            '3.订单金额中使用京东E卡支付的部分，不提供发票。\n' +
            '4.退货时，京东E卡支付部分退回原京东E卡内，不予兑换。\n' +
            '5.单张京东E卡可多次使用，每笔订单可以使用多张京东E卡，但个别情况下由于浏览器的不同，一次使用多张京东E卡的张数不定，最多为49张，京东E卡不可兑换现金。\n' +
            '6.京东E卡和京东卡暂时不能同时使用。\n' +
            '7.打开京东APP点击“我的”、“我的钱包”、“礼品卡”、“绑定新卡”输入卡密和验证码，立刻绑定即可；第一次使用京东E卡之前，请先在京东开启支付密码(请到“我的京东(我的订单)>账户中心>账户安全”中开启支付密码)。\n' +
            '8.京东E卡只能在京东商城(www.jd.com)购买产品时使用。京东E卡在使用时没有最低消费金额，仅可购买京东网上商城的自营商品(“自营商品”指在商品详情页明确标识为‘商品从京东库房出库，由京东安排配送，且商品发票由京东提供的商品，但出版物、虚拟产品、预售、及抢购商品、投资金银类、夺宝岛、京东国际、京东大药房、第三方卖家商品及受国家政策影响、法律另有限制性规定涉及的商品不在此范围内。)“不可用于京东国际自营商品”\n' +
            '9.请在2021年4月31日前使用。'
    },
    {
        type: 2,
        productId: 'JDEK100YDTZY20210219172604379',
        productName: '京东E卡100元',
        coinNum: 220,
        icon: iconJD,
        rule: '1.建议尽快使用，过期自动作废，无法延期或退换，请谅解!\n' +
            '2.京东E卡绑定账户后， 只能当前账户使用，不能跨账户使用。\n' +
            '3.订单金额中使用京东E卡支付的部分，不提供发票。\n' +
            '4.退货时，京东E卡支付部分退回原京东E卡内，不予兑换。\n' +
            '5.单张京东E卡可多次使用，每笔订单可以使用多张京东E卡，但个别情况下由于浏览器的不同，一次使用多张京东E卡的张数不定，最多为49张，京东E卡不可兑换现金。\n' +
            '6.京东E卡和京东卡暂时不能同时使用。\n' +
            '8.打开京东APP点击“我的”、“我的钱包”、“礼品卡”、“绑定新卡”输入卡密和验证码，立刻绑定即可；第一次使用京东E卡之前，请先在京东开启支付密码(请到“我的京东(我的订单)>账户中心>账户安全”中开启支付密码)。\n' +
            '9.京东E卡只能在京东商城(www.jd.com)购买产品时使用。京东E卡在使用时没有最低消费金额，仅可购买京东网上商城的自营商品(“自营商品”指在商品详情页明确标识为‘商品从京东库房出库，由京东安排配送，且商品发票由京东提供的商品，但出版物、虚拟产品、预售、及抢购商品、投资金银类、夺宝岛、京东国际、京东大药房、第三方卖家商品及受国家政策影响、法律另有限制性规定涉及的商品不在此范围内。)“不可用于京东国际自营商品”\n' +
            '10.请在2021年4月31日前使用。'
    },

]